import { useFetchNextAppointments as useSharedFetchNextAppointments } from '@avanta/shared/hooks/useFetchNextAppointments';
import { type Appointment } from '@avanta/shared/types/appointments';
import { type UseQueryResult } from '@tanstack/react-query';
import { useIsSupporter, useUserStore } from 'stores/user';

export const useFetchNextAppointments = (
  patientId: string,
  psychologistId?: string
): UseQueryResult<Appointment[]> => {
  const currentUser = useUserStore(state => state.user);
  const isSupporter = useIsSupporter();
  return useSharedFetchNextAppointments({
    patientId,
    psychologistId,
    currentUser,
    enabled: !isSupporter,
  });
};
